module.exports = __webpack_public_path__ + "static/media/chen23HIL.1d839984.gif";